import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import styles from "./Hero.module.css";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.08, delayChildren: 0.08 },
  },
};

const item = {
  hidden: { opacity: 0, y: 14, filter: "blur(6px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  },
};

const TABS = [
  { id: "feed", label: "Feed", icon: "🌐" },
  { id: "search", label: "Search", icon: "⌕" },
  { id: "create", label: "Create", icon: "⊕" },
  { id: "plans", label: "Plans", icon: "📅", badge: 1 },
  { id: "me", label: "Me", icon: "☺" },
];

const FEED_PLANS = [
  {
    countdown: "STARTS IN 1 DAY 12 HRS",
    day: "18",
    time: "6:00 AM",
    host: "Mansi",
    hostAvatar: "/avatars/avatar-1.png",
    title: "Weekend trip",
    subtitle: "Two days trip",
    avatars: ["/avatars/avatar-3.png", "/avatars/avatar-5.png"],
  },
  {
    countdown: "STARTS IN 2 DAYS 4 HRS",
    day: "19",
    time: "11:00 AM",
    host: "Aanya",
    hostAvatar: "/avatars/avatar-3.png",
    title: "Sunday Brunch",
    subtitle: "Brunch with friends",
    avatars: ["/avatars/avatar-4.png", "/avatars/avatar-5.png"],
  },
  {
    countdown: "STARTS IN 3 DAYS 8 HRS",
    day: "20",
    time: "8:00 PM",
    host: "Dev",
    hostAvatar: "/avatars/avatar-4.png",
    title: "Friday Dinner",
    subtitle: "Cozy dinner plans",
    avatars: ["/avatars/avatar-6.png", "/avatars/avatar-7.png"],
  },
];

const MY_PLANS = [
  { title: "Sunday Brunch", when: "Sat · 11:00 AM", what: "Open brunch with friends", privacy: "public", privacyLabel: "Public" },
  { title: "Friday Dinner", when: "Tonight · 8:00 PM", what: "Cozy dinner with friends", privacy: "private", privacyLabel: "Private" },
  { title: "Girls night", when: "Sat · 9:00 PM", what: "Invite-only hangout", privacy: "invite", privacyLabel: "Invite only" },
];

const CREATE_PRIVACY = [
  { id: "public", label: "Public" },
  { id: "private", label: "Private" },
  { id: "invite", label: "Invite only" },
];

const REQUESTS = [
  { name: "Aanya R.", plan: "Girls night", when: "Sat · 9 PM", what: "Wants to join your plan" },
];

const CREATE_CATS = [
  { emoji: "☕", label: "Coffee" },
  { emoji: "🍽️", label: "Dinner" },
  { emoji: "✈️", label: "Travel" },
  { emoji: "🎬", label: "Movie" },
  { emoji: "🚴", label: "Bike ride" },
];

const SHARED_TIMELINE = [
  {
    date: "7 Sept",
    title: "Night out",
    avatars: ["/avatars/avatar-2.png", "/avatars/avatar-4.png", "/avatars/avatar-6.png"],
    thumbs: [],
  },
  {
    date: "31 Aug",
    title: "Clay date",
    avatars: ["/avatars/avatar-3.png", "/avatars/avatar-5.png", "/avatars/avatar-7.png"],
    thumbs: ["/memories/memory-2.png"],
  },
  {
    date: "31 Aug",
    title: "Pickleball",
    avatars: ["/avatars/avatar-4.png", "/avatars/avatar-2.png", "/avatars/avatar-6.png"],
    thumbs: ["/memories/memory-3.png", "/memories/memory-5.png"],
  },
  {
    date: "29 Aug",
    title: "Girls night & drinks",
    avatars: ["/avatars/avatar-5.png", "/avatars/avatar-1.png", "/avatars/avatar-3.png"],
    thumbs: ["/memories/memory-1.png", "/memories/memory-4.png"],
  },
];

const SOCIAL_LINKS = [
  { id: "wa", label: "WhatsApp" },
  { id: "ig", label: "Instagram" },
  { id: "li", label: "LinkedIn" },
  { id: "sn", label: "Snapchat" },
];

function SocialIcon({ id }) {
  const common = {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": true,
  };

  if (id === "wa") {
    return (
      <svg {...common}>
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    );
  }

  if (id === "ig") {
    return (
      <svg {...common}>
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    );
  }

  if (id === "li") {
    return (
      <svg {...common}>
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    );
  }

  return (
    <svg {...common}>
      <path d="M12.206.793c-.086-.086-.222-.086-.308 0C9.8 2.89 6.886 4.282 3.7 4.282c-.172 0-.31.138-.31.31v.034c0 4.124 1.68 7.93 4.36 10.55.86.86 1.8 1.594 2.8 2.186.172.1.38.1.552 0 1-.592 1.94-1.326 2.8-2.186 2.68-2.62 4.36-6.426 4.36-10.55v-.034c0-.172-.138-.31-.31-.31-3.186 0-6.1-1.392-8.198-3.49z" />
    </svg>
  );
}

export default function Hero({ tagline, subTagline, description, onPrimary, onSecondary }) {
  const [tab, setTab] = useState("feed");
  const [plansView, setPlansView] = useState("mine");
  const [meView, setMeView] = useState("shared");
  const [createCat, setCreateCat] = useState(0);
  const [createPrivacy, setCreatePrivacy] = useState("private");
  const [feedIdx, setFeedIdx] = useState(0);
  const [feedDir, setFeedDir] = useState(1);

  const goNextFeed = () => {
    setFeedDir(1);
    setFeedIdx((i) => (i + 1) % FEED_PLANS.length);
  };

  const goPrevFeed = () => {
    setFeedDir(-1);
    setFeedIdx((i) => (i - 1 + FEED_PLANS.length) % FEED_PLANS.length);
  };

  const activeFeed = FEED_PLANS[feedIdx];

  const onFeedDragEnd = (_e, info) => {
    if (info.offset.y < -56 || info.velocity.y < -400) goNextFeed();
    else if (info.offset.y > 56 || info.velocity.y > 400) goPrevFeed();
  };

  return (
    <section className={styles.hero}>
      <div className={`container ${styles.inner}`}>
        <motion.div
          variants={container}
          initial="hidden"
          animate="show"
          className={styles.copy}
        >
          <motion.div variants={item} className={styles.kicker}>
            <span className={styles.dot} aria-hidden="true" />
            Plans · invites · memories · timelines
          </motion.div>

          <motion.h1 variants={item} className={styles.title}>
            Timeline
          </motion.h1>

          <motion.p variants={item} className={styles.tagline}>
            <span className={styles.taglineStrong}>{tagline}</span>
            {subTagline ? (
              <span className={styles.taglineSoft}>{subTagline}</span>
            ) : null}
          </motion.p>

          <motion.p variants={item} className={styles.desc}>
            {description}
          </motion.p>

          <motion.div variants={item} className={styles.ctaRow}>
            <button className={styles.primary} onClick={onPrimary}>
              Download the app
            </button>
            <button className={styles.secondary} onClick={onSecondary}>
              See plans demo
            </button>
          </motion.div>

          <motion.div variants={item} className={styles.trustRow}>
            <div className={styles.trustPill}>Create a plan</div>
            <div className={styles.trustPill}>Invite people</div>
            <div className={styles.trustPill}>Post memories</div>
          </motion.div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className={styles.scene}
          aria-label="Interactive plans preview"
        >
          <div className={`${styles.phone} ${tab === "feed" ? styles.phoneFeedMode : ""}`}>
            <div className={styles.phoneNotch} />
            <div className={`${styles.phoneScreen} ${tab === "feed" ? styles.phoneScreenFeed : ""}`}>
              {(tab === "search" || tab === "plans") && (
                <div className={styles.phoneTop}>
                  <div className={styles.searchBar}>
                    {tab === "search" ? "Search people and plans" : "Your plans"}
                  </div>
                </div>
              )}

              <div className={`${styles.phoneBody} ${tab === "feed" ? styles.phoneBodyFeed : ""}`}>
                <AnimatePresence mode="wait">
                  {tab === "feed" && (
                    <motion.div
                      key="feed"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.2 }}
                      className={styles.feedImmersive}
                    >
                      <button
                        type="button"
                        className={styles.feedAddBtn}
                        aria-label="Create plan"
                        onClick={() => setTab("create")}
                      >
                        +
                      </button>

                      <AnimatePresence mode="wait" custom={feedDir}>
                        <motion.article
                          key={activeFeed.title}
                          className={styles.feedSlide}
                          custom={feedDir}
                          initial={{ y: feedDir > 0 ? 48 : -48, opacity: 0 }}
                          animate={{ y: 0, opacity: 1 }}
                          exit={{ y: feedDir > 0 ? -64 : 64, opacity: 0 }}
                          transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
                          drag="y"
                          dragConstraints={{ top: 0, bottom: 0 }}
                          dragElastic={0.18}
                          onDragEnd={onFeedDragEnd}
                        >
                          <div className={styles.feedSlideTop}>
                            <div className={styles.feedCountdown}>{activeFeed.countdown}</div>
                            <div className={styles.feedDay}>{activeFeed.day}</div>
                            <div className={styles.feedTime}>{activeFeed.time}</div>

                            <div className={styles.feedHostRow}>
                              <img src={activeFeed.hostAvatar} alt="" className={styles.feedHostImg} />
                              <span>{activeFeed.host}</span>
                            </div>

                            <h3 className={styles.feedPlanTitle}>{activeFeed.title}</h3>
                            <p className={styles.feedPlanSub}>{activeFeed.subtitle}</p>

                            <div className={styles.feedPeople}>
                              {activeFeed.avatars.map((src) => (
                                <img key={src} src={src} alt="" className={styles.feedPerson} />
                              ))}
                            </div>
                          </div>

                          <div className={styles.feedSlideBottom}>
                            <button type="button" className={styles.feedRequestBtn}>
                              Request
                            </button>
                            <div className={styles.feedSwipeHint}>Swipe up for next</div>
                          </div>
                        </motion.article>
                      </AnimatePresence>
                    </motion.div>
                  )}

                  {tab === "search" && (
                    <motion.div
                      key="search"
                      initial={{ opacity: 0, x: 12 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -12 }}
                      transition={{ duration: 0.22 }}
                      className={styles.panel}
                    >
                      <div className={styles.searchHint}>Find people from gym, college, work, or travel.</div>
                      {["Aanya", "Dev", "Priya"].map((name, i) => (
                        <div key={name} className={styles.searchRow}>
                          <img src={`/avatars/avatar-${i + 1}.png`} alt="" className={styles.searchAvatar} />
                          <div>
                            <strong>{name}</strong>
                            <div>@{name.toLowerCase()}</div>
                          </div>
                        </div>
                      ))}
                    </motion.div>
                  )}

                  {tab === "create" && (
                    <motion.div
                      key="create"
                      initial={{ opacity: 0, x: 12 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -12 }}
                      transition={{ duration: 0.22 }}
                      className={styles.panel}
                    >
                      <div className={styles.createTitle}>Create a plan</div>
                      <div className={styles.createCats}>
                        {CREATE_CATS.map((c, i) => (
                          <button
                            key={c.label}
                            type="button"
                            className={`${styles.createCat} ${createCat === i ? styles.createCatOn : ""}`}
                            onClick={() => setCreateCat(i)}
                          >
                            <span>{c.emoji}</span>
                            <span className={styles.createCatLabel}>{c.label}</span>
                          </button>
                        ))}
                      </div>
                      <div className={styles.createField}>{CREATE_CATS[createCat].label} plan</div>
                      <div className={styles.createField}>Choose date and time</div>
                      <div className={styles.privacyRow}>
                        {CREATE_PRIVACY.map((opt) => (
                          <button
                            key={opt.id}
                            type="button"
                            className={createPrivacy === opt.id ? styles.privacyOn : undefined}
                            onClick={() => setCreatePrivacy(opt.id)}
                          >
                            {opt.label}
                          </button>
                        ))}
                      </div>
                      <div className={styles.createCta}>Create plan</div>
                    </motion.div>
                  )}

                  {tab === "plans" && (
                    <motion.div
                      key="plans"
                      initial={{ opacity: 0, x: 12 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -12 }}
                      transition={{ duration: 0.22 }}
                      className={styles.panel}
                    >
                      <div className={styles.plansTabs}>
                        <button
                          type="button"
                          className={`${styles.plansTabBtn} ${plansView === "mine" ? styles.plansTabOn : ""}`}
                          onClick={() => setPlansView("mine")}
                        >
                          My plans
                        </button>
                        <button
                          type="button"
                          className={`${styles.plansTabBtn} ${plansView === "requests" ? styles.plansTabOn : ""}`}
                          onClick={() => setPlansView("requests")}
                        >
                          Requests <em>1</em>
                        </button>
                      </div>

                      {plansView === "mine" ? (
                        MY_PLANS.map((p) => (
                          <div key={p.title} className={styles.planDetailCard}>
                            <div className={styles.planDetailTop}>
                              <strong>{p.title}</strong>
                              <span
                                className={
                                  p.privacy === "public"
                                    ? styles.badgePublic
                                    : p.privacy === "private"
                                      ? styles.badgePrivate
                                      : styles.badgeInvite
                                }
                              >
                                {p.privacyLabel}
                              </span>
                            </div>
                            <div className={styles.planDetailRow}>🕒 {p.when}</div>
                            <div className={styles.planDetailRow}>{p.what}</div>
                          </div>
                        ))
                      ) : (
                        REQUESTS.map((r) => (
                          <div key={r.name} className={styles.planDetailCard}>
                            <div className={styles.planDetailTop}>
                              <strong>{r.name}</strong>
                              <span className={styles.badgeInvite}>Request</span>
                            </div>
                            <div className={styles.planDetailRow}>Plan: {r.plan}</div>
                            <div className={styles.planDetailRow}>🕒 {r.when}</div>
                            <div className={styles.planDetailRow}>{r.what}</div>
                            <div className={styles.reqActions}>
                              <span className={styles.accept}>Accept</span>
                              <span className={styles.decline}>Decline</span>
                            </div>
                          </div>
                        ))
                      )}
                    </motion.div>
                  )}

                  {tab === "me" && (
                    <motion.div
                      key="me"
                      initial={{ opacity: 0, x: 12 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -12 }}
                      transition={{ duration: 0.22 }}
                      className={styles.profilePanel}
                    >
                      <div className={styles.profileTools} aria-hidden="true">
                        <span>🔔</span>
                        <span>ℹ</span>
                        <span>⚙</span>
                        <span>↗</span>
                      </div>

                      <div className={styles.profileHeader}>
                        <div className={styles.meAvatarWrap}>
                          <img src="/avatars/avatar-1.png" alt="" className={styles.meAvatarLg} />
                          <span className={styles.meAvatarAdd}>+</span>
                        </div>
                        <div className={styles.profileMeta}>
                          <strong className={styles.meName}>Mansi s</strong>
                          <div className={styles.meBio}>This is the beginning of my timeline</div>
                        </div>
                      </div>

                      <div className={styles.profileActions}>
                        <span className={styles.circleBtn}>👥 Circle</span>
                        <span className={styles.editBtn}>✎ Edit profile</span>
                      </div>

                      <div className={styles.socialRow} aria-hidden="true">
                        {SOCIAL_LINKS.map((s) => (
                          <span key={s.id} className={`${styles.socialBtn} ${styles[`social_${s.id}`]}`} title={s.label}>
                            <SocialIcon id={s.id} />
                          </span>
                        ))}
                      </div>

                      <div className={styles.meTabs}>
                        <button
                          type="button"
                          className={`${styles.meTabBtn} ${meView === "shared" ? styles.meTabOn : ""}`}
                          onClick={() => setMeView("shared")}
                        >
                          19 Timeline
                        </button>
                        <button
                          type="button"
                          className={`${styles.meTabBtn} ${meView === "photos" ? styles.meTabOn : ""}`}
                          onClick={() => setMeView("photos")}
                        >
                          1 Photos
                        </button>
                      </div>

                      {meView === "shared" && (
                        <div className={styles.sharedTimelineWrap}>
                          <div className={styles.sharedTimeline}>
                            {SHARED_TIMELINE.map((mem, idx) => (
                              <div key={`${mem.title}-${mem.date}`} className={styles.tlItem}>
                                <div className={`${styles.tlDate} ${idx === 0 ? styles.tlDateOn : ""}`}>
                                  {mem.date}
                                </div>
                                <div className={styles.tlRail} aria-hidden="true">
                                  <span className={`${styles.tlDot} ${idx === 0 ? styles.tlDotOn : ""}`} />
                                </div>
                                <div className={styles.tlCard}>
                                  <div className={styles.tlCardTop}>
                                    <strong className={styles.tlTitle}>{mem.title}</strong>
                                    <div className={styles.tlAvatars}>
                                      {mem.avatars.map((src) => (
                                        <img key={src} src={src} alt="" className={styles.tlAvatar} />
                                      ))}
                                    </div>
                                  </div>
                                  {mem.thumbs.length > 0 && (
                                    <div className={styles.tlThumbs}>
                                      {mem.thumbs.map((src) => (
                                        <img key={src} src={src} alt="" className={styles.tlThumb} />
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className={styles.viewToggle} aria-hidden="true">
                            <span className={styles.viewToggleOn}>☰</span>
                            <span>▦</span>
                          </div>
                        </div>
                      )}

                      {meView === "photos" && (
                        <div className={styles.photoGrid}>
                          {[1, 2, 3, 4, 5, 6].map((n) => (
                            <img
                              key={n}
                              src={`/memories/memory-${n}.png`}
                              alt=""
                              className={styles.photoCell}
                            />
                          ))}
                        </div>
                      )}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

              <nav className={`${styles.tabBar} ${tab === "feed" ? styles.tabBarFeed : ""}`} aria-label="App tabs">
                {TABS.map((t) => (
                  <button
                    key={t.id}
                    type="button"
                    className={`${styles.tabBtn} ${tab === t.id ? styles.tabBtnActive : ""}`}
                    onClick={() => setTab(t.id)}
                  >
                    <span className={styles.tabIconWrap}>
                      <span className={styles.tabIcon}>{t.icon}</span>
                      {t.badge ? <em className={styles.tabBadge}>{t.badge}</em> : null}
                    </span>
                    <span>{t.label}</span>
                  </button>
                ))}
              </nav>
            </div>
          </div>
        </motion.div>
      </div>

      <div className={styles.bg} aria-hidden="true">
        <div className={styles.blobA} />
        <div className={styles.blobB} />
        <div className={styles.blobC} />
        <div className={styles.noise} />
      </div>
    </section>
  );
}
